import React from 'react';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { styles } from './styles';

interface EditBreadcrumbsProps {
  current: string;
}

const EditBreadcrumbs: React.FC<EditBreadcrumbsProps> = ({ current }) => {
  const navigate = useNavigate();

  return (
    <Breadcrumbs separator="›" aria-label="breadcrumb" sx={styles.breadcrumbs}>
      <Link
        underline="hover"
        sx={styles.link}
        onClick={() => navigate('/my-account')}
      >
        Minha conta
      </Link>
      <Typography sx={styles.current}>{current}</Typography>
    </Breadcrumbs>
  );
};

export default EditBreadcrumbs;
